<template>
  <div class="Equipment-Report-Main">
    <div class="content-container">
      <div class="left-container" resizable>
        <div class="filter-container" style="flex-grow: 1">
          <div style="font-weight: bold; margin-bottom: 2px; font-size: 0.85rem">Report Filters</div>
          <Dropdown
            placeholder="Report Type"
            :selectedObject.sync="selectedReportName"
            :items="reportNameData"
            itemKey="Report"
            :isRequired="true"
            :errorMessage.sync="errorReportName"
            @selected="resetDateFields"
            style="margin-bottom: 8px"
          />

          <div class="d-flex flex-column" style="margin-bottom: 8px" v-if="!disableDateFields && selectedReportName">
            <Dropdown
              :items="activeDateFields"
              :isDisabled="activeDateFields.length <= 1"
              :selectedObject.sync="selectedDateField"
              itemKey="Date Field"
              placeholder="Date Filter"
              v-if="activeDateFields.length > 0"
            />
            <div class="d-flex align-items-center">
              <CheckBox title="" :isChecked.sync="showFromDate" @checkBoxClicked="fromDateCheckBoxClicked" />
              <DateTimePicker
                placeholder="Start Date"
                style="height: auto; top: 0"
                :value.sync="selectedFromDate"
                :showTime="false"
                :errorMessage.sync="errorFromDate"
                :isDisabled="!showFromDate"
              />
            </div>
            <div class="d-flex align-items-center">
              <CheckBox title="" :isChecked.sync="showToDate" @checkBoxClicked="toDateCheckBoxClicked" />
              <DateTimePicker
                placeholder="End Date"
                style="height: auto; top: 0"
                :value.sync="selectedToDate"
                :showTime="false"
                :errorMessage.sync="errorToDate"
                :isDisabled="!showToDate"
              />
            </div>
          </div>

          <div v-if="selectedReportCode == 'EQUIPMENT_POLICY_EXPIRY'" class="active-filter-container">
            <Filters
              style="flex-basis: 120px"
              title="Equipment Category"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="selectedEquipmentCategory"
            />
          </div>

          <div
            v-if="selectedReportCode == 'STOCK_DAILY_MOVEMENT' || selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL'"
            class="active-filter-container"
          >
            <Filters
              style="flex-basis: 80px"
              title="Warehouse"
              itemKey="Warehouse Code"
              :isFullScreen="true"
              :tableData="warehouseList"
              :selectedObject.sync="dailyWarehouseValue"
            />
            <Filters
              style="flex-basis: 80px"
              title="Product"
              itemKey="Product Code"
              :isFullScreen="true"
              :tableData="whProductList"
              :selectedObject.sync="dailyItemValue"
            />
            <!-- <Filters
              style="flex-basis: 80px"
              title="Supplier"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="supplierList"
              :selectedObject.sync="dailySupplierValue"
            /> -->
          </div>

          <InputQuery
            placeholder="Vehicle"
            v-if="selectedReportCode == 'VEHICLE_AVAILABILITY'"
            class="mb-3"
            :isRequired="true"
            :items="vehicleList"
            :selectedObject.sync="vehicleAvailabilityVehicleValue"
            itemKey="label"
            :errorMessage.sync="vehicleAvailabilityVehicleValueError"
          />

          <div v-if="selectedReportCode == 'TYRE_USAGE'" class="active-filter-container">
            <Filters
              style="flex-basis: 100px"
              title="Vehicle"
              itemKey="label"
              :isFullScreen="true"
              :tableData="vehicleList"
              :selectedObject.sync="tyreUsageVehicleValue"
            />
            <Filters
              style="flex-basis: 100px"
              title="Vehicle Type"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="tyreUsageVehicleTypeValue"
            />
          </div>

          <div v-if="selectedReportCode == 'JOB_ANALYSIS'" class="active-filter-container">
            <Dropdown
              placeholder="Report Type"
              :items="jobAnalysisTypes"
              :selectedObject.sync="jobAnalysisTypeValue"
              :errorMessage.sync="jobAnalysisTypeValueError"
              :isRequired="true"
              itemKey="label"
            />
            <Filters
              style="flex-basis: 120px"
              title="Vehicle Type"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="jobAnalysisVehicleTypeValue"
            />
          </div>

          <div v-if="selectedReportCode == 'PARTS_USAGE'" class="active-filter-container">
            <Filters
              style="flex-basis: 100px"
              title="Part Type"
              itemKey="Part Type"
              :isFullScreen="true"
              :tableData="partTypeSet"
              :selectedObject.sync="partsUsagePartTypeValue"
            />
            <Filters
              style="flex-basis: 100px"
              title="Part Group"
              itemKey="Part Group"
              :isFullScreen="true"
              :tableData="partGroupSet"
              :selectedObject.sync="partsUsagePartGroupValue"
            />
          </div>

          <div v-if="selectedReportCode == 'MAINTENANCE'" class="active-filter-container">
            <Filters
              style="flex-basis: 100px"
              title="Vehicle Type"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="maintenanceVehicleTypeValue"
            />
          </div>

          <Button @click="refreshClicked" :disabled="!selectedReportName" class="mb-1">Refresh</Button>
        </div>
        <div class="filter-container" style="flex-shrink: 0">
          <div style="font-weight: bold; margin-bottom: 2px; font-size: 0.85rem">Active Filters</div>

          <Input placeholder="Report Type" :isDisabled="true" :inputValue.sync="injectedReportName" />

          <div class="d-flex flex-column" v-if="injectedReportCode && !disableDateFieldsInjected">
            <div v-if="injectedDateField">{{ injectedDateField }}:</div>
            <DateTimePicker
              placeholder="Start Date"
              :isDisabled="true"
              :showTime="false"
              :value.sync="injectedFromDate"
              v-if="injectedFromDate"
            />
            <DateTimePicker
              placeholder="End Date"
              :isDisabled="true"
              :showTime="false"
              :value.sync="injectedToDate"
              v-if="injectedToDate"
            />
          </div>

          <div class="d-flex flex-column" v-if="injectedReportCode == 'EQUIPMENT_POLICY_EXPIRY'">
            <Input placeholder="Equipment Category" :isDisabled="true" :inputValue.sync="injectedEquipmentCategory" />
          </div>
          <div
            class="d-flex flex-column"
            v-else-if="
              injectedReportCode == 'STOCK_DAILY_MOVEMENT' || selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL'
            "
          >
            <Input placeholder="Warehouse" :isDisabled="true" :inputValue.sync="injectedDailyWarehouse" />
            <Input placeholder="Product" :isDisabled="true" :inputValue.sync="injectedDailyItem" />
            <!-- <Input placeholder="Supplier" :isDisabled="true" :inputValue.sync="injectedDailySupplier" /> -->
          </div>
          <Input
            :isDisabled="true"
            v-else-if="injectedReportCode == 'VEHICLE_AVAILABILITY'"
            placeholder="Vehicle"
            :inputValue.sync="injectedVehicleAvailabilityVehicle"
          />
          <div v-else-if="injectedReportCode == 'TYRE_USAGE'">
            <Input :isDisabled="true" placeholder="Vehicle" :inputValue.sync="injectedTyreUsageVehicle" />
            <Input :isDisabled="true" placeholder="Vehicle Type" :inputValue.sync="injectedTyreUsageVehicleType" />
          </div>

          <div v-else-if="injectedReportCode == 'JOB_ANALYSIS'">
            <Input placeholder="Report Type" :inputValue="injectedJobAnalysisType" :isDisabled="true" />
            <Input placeholder="Vehicle Type" :inputValue="injectedJobAnalysisVehicleType" :isDisabled="true" />
          </div>

          <div v-else-if="injectedReportCode == 'PARTS_USAGE'">
            <Input placeholder="Part Type" :isDisabled="true" :inputValue="injectedPartsUsagePartType" />
            <Input placeholder="Part Group" :isDisabled="true" :inputValue="injectedPartsUsagePartGroup" />
          </div>
          <Input
            v-else-if="injectedReportCode == 'MAINTENANCE'"
            placeholder="Vehicle Type"
            :isDisabled="true"
            :inputValue="injectedMaintenanceVehicleTypeValue"
          />
        </div>
      </div>
      <div class="table-container">
        <TableBox
          :title="injectedReportName"
          :tableData="reportTableData"
          style="min-height: 0; min-width: 0"
          v-if="reportTableData"
          :hideColumns="tableHideFiltered"
          :groupBy="tableGroupBy"
          :lastRefreshed="lastRefreshed"
          :dataType="tableDataType"
        />
        <div v-if="reportTableData" class="d-flex align-items-center mt-2 w-100" style="gap: 8px">
          <div
            class="d-flex align-items-center"
            style="gap: 12px"
            v-if="injectedReportCode == 'EQUIPMENT_POLICY_EXPIRY'"
          >
            <div class="mr-1">Legend: </div>
            <div class="d-flex align-items-center" style="gap: 4px">
              <img style="height: 20px; width: 20px" src="https://dsmlib.logistics.systems/Icons/error.png" />
              <div>Policy Expired</div>
            </div>
            <div class="d-flex align-items-center" style="gap: 4px">
              <img style="height: 20px; width: 20px" src="https://dsmlib.logistics.systems/Icons/warning.png" />
              <div> Policy Expire in {{ settingvalue }} days</div>
            </div>
          </div>

          <div v-if="injectedReportCode == 'TYRE_USAGE'" class="d-flex" style="gap: 8px">
            Group By:
            <CheckBox
              title="Vehicle No"
              :isChecked.sync="tyreUsageGroupInventoryNo"
              @checkBoxClicked="tyreUsageGroupVehicleClick"
            />
            <CheckBox
              title="Serial No"
              :isChecked.sync="tyreUsageGroupSerialNo"
              @checkBoxClicked="tyreUsageGroupSerialClick"
            />
          </div>
          <div v-if="injectedReportCode == 'JOB_ANALYSIS' && injectedJobAnalysisType == 'Duration / Mileage Diff.'">
            <CheckBox
              title="Group Serial No"
              :isChecked.sync="jobAnalysisGroupByInventoryNo"
              @checkBoxClicked="refreshTableData"
            />
          </div>
        </div>
        <div v-else style="max-width: 420px; text-align: center; font-size: 1.25rem; width: 100%">
          <span> Enter Report Filters and click on <b>Refresh Table</b> to get started</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      reportNameData: [],
      dateFieldData: [],
      equipmentCategoryList: [],
      policyTypes: [], // stores POLICYTYPE masterfile data
      reportTableData: null,
      policyExpiryDateDataType: {
        NCB: 'number',
        'Lorry Length': 'number',
      },

      selectedReportName: null,

      // Equipment Expiry Date
      selectedDateField: null,
      selectedEquipmentCategory: [],
      selectedFromDate: null,
      selectedToDate: null,

      // Stock Daily Movement
      dailyWarehouseValue: [],
      dailyItemValue: [],
      dailySupplierValue: [],
      dailyFromDate: null,
      dailyToDate: null,

      // Vehicle Availability
      vehicleAvailabilityVehicleValue: null,
      vehicleAvailabilityVehicleValueError: '',

      // Tyre Usage
      tyreUsageVehicleValue: [],
      tyreUsageVehicleTypeValue: [],
      tyreUsageGroupSerialNo: false,
      tyreUsageGroupInventoryNo: false,
      tyreUsageTyreStatusTypes: [
        {
          label: 'All',
          keyValue: 'all',
        },
        { label: 'In Use', keyValue: '1' },
        { label: 'Retreading', keyValue: '3' },
        { label: 'Discard', keyValue: '4' },
        { label: 'Sent To Warehouse', keyValue: '5' },
        { label: 'Unavailable', keyValue: '0' },
      ],

      // Job Analysis
      jobAnalysisTypeValue: null,
      jobAnalysisTypeValueError: '',
      jobAnalysisVehicleTypeValue: [],
      jobAnalysisTypes: [
        {
          label: 'Duration / Mileage Diff.',
          keyValue: 'diff',
        },
        {
          label: 'Total Repair Count',
          keyValue: 'count',
        },
      ],
      jobAnalysisGroupByInventoryNo: false,

      // Parts Usage
      partsUsagePartTypeValue: [],
      partsUsagePartGroupValue: [],

      // Vehicle Maintenance
      maintenanceVehicleTypeValue: [],

      warehouseList: [],
      whProductList: [],
      supplierList: [],
      vehicleList: [],
      emsparttypeList: [],

      settingvalue: '', // From GetSystemSetting (alert before expiry of policy)
      errorReportName: '',
      errorDateField: '',
      errorEquipmentCategory: '',
      errorFromDate: '',
      errorToDate: '',

      injectedReportName: '',
      injectedReportCode: '',

      injectedDateField: '',

      //Active stuff

      // Equipment Expiry Date active
      injectedEquipmentCategory: '',
      injectedFromDate: '',
      injectedToDate: '',

      // Stock Daily Movement active
      injectedDailyWarehouse: '',
      injectedDailyItem: '',
      injectedDailySupplier: '',
      injectedDailyFromDate: '',
      injectedDailyToDate: '',

      // Vehicle Availability active
      injectedVehicleAvailabilityVehicle: '',

      // Tyre Usage
      injectedTyreUsageVehicle: '',
      injectedTyreUsageVehicleType: '',

      // Job Analysis
      injectedJobAnalysisType: '',
      injectedJobAnalysisVehicleType: '',

      // Parts Usage
      injectedPartsUsagePartType: '',
      injectedPartsUsagePartGroup: '',

      // Maintenance
      injectedMaintenanceVehicleTypeValue: '',

      closeLeftTab: false,
      lastRefreshed: null,

      showFromDate: true,
      showToDate: false,

      tableHideColumns: [],

      stockMovementTableHide: ['prodtxnid'],
      jobAnalysisDiffTableHide: ['Vehicle No', 'Vehicle Code', 'Vehicle Category'],

      localCurrency: 'MYR',

      tableDataType: {},

      expiryDataType: {
        'Equipment Category': 'string',
        'Inventory No': 'string',
        'Vehicle Code': 'string',
        'Chassis No': 'string',
        NCB: 'number',
        'Current Driver': 'string',
        'Lorry Length': 'number',
        'ROAD TAX': 'date',
        INSURANCE: 'date',
        PERMIT: 'date',
        INSPECTION: 'date',
      },

      stockDataType: {
        '#': 'string',
        Product: 'string',
        Warehouse: 'string',
        'Serial No': 'string',
        'Balance Before': 'number',
        'Qty Received': 'number',
        'Qty Issued': 'number',
        'Qty Change': 'number',
        'Qty Balance': 'number',
        Date: 'date',
        'Job No': 'string',
        'Vehicle No': 'string',
      },

      vehicleAvailabilityDataType: {
        '#': 'string',
        'Vehicle No': 'string',
        'Vehicle Code': 'string',
        Availability: 'string',
        Remark: 'string',
        'Audit Date': 'datetime',
        'Audit User': 'string',
      },
      tyreUsageDataType: {
        '#': 'string',
        'Vehicle No': 'string',
        'Serial No': 'string',
        Model: 'string',
        Manufacturer: 'string',
        'Made In': 'string',
        'Tyre Size': 'string',
        'No of Retread': 'number',
        'Tyre Position': 'string',
        'Tyre Status': 'string',
        'Mileage In Use': 'number',
        'Date Changed': 'date',
        'Days In Use': 'number',
        'Date Last Use': 'date',
        'Job No': 'string',
      },

      jobAnalysisDataType: {
        '#': 'string',
        'Vehicle No': 'string',
        'Vehicle Code': 'string',
        'Vehicle Category': 'string',
        'Total Repair Count': 'number',
        [`Total Amount (${this.localCurrency})`]: 'currency',
        'Current Mileage': 'number',
        'Age of Vehicle (Year)': 'number',
        'Vehicle No': 'string',
        'Vehicle Code': 'string',
        'Vehicle Category': 'string',
        'Job No': 'string',
        'Job Date': 'date',
        Workshop: 'string',
        'Date In': 'date',
        'Time In': 'string',
        'Date Out': 'date',
        'Time Out': 'string',
        'Duration (Days)': 'number',
        [`Amount (${this.localCurrency})`]: 'currency',
        Mileage: 'number',
        'Mileage Diff': 'number',
        'Service Person': 'string',
      },

      partUsageDataType: {
        '#': 'string',
        Vehicle: 'string',
        'Job No': 'string',
        'Job Date': 'datetime',
        'Part Type': 'string',
        'Part No': 'string',
        'Serial No': 'string',
        'Date Purchase': 'datetime',
        Supplier: 'string',
        Manufacturer: 'string',
        'Made In': 'string',
        Model: 'string',
        Size: 'string',
        Quantity: 'number',
        'Unit Price': 'currency',
        [`Cost (${this.localCurrency})`]: 'currency',
        Mileage: 'number',
        'Usage (KM)': 'number',
        'Cost per KM': 'currency',
        'Date Out': 'date',
        'Tyre Position': 'string',
        'Invoice No': 'string',
      },

      maintenanceDataType: {
        '#': 'string',
        Vehicle: 'string',
        Service: 'string',
        Task: 'string',
        Remarks: 'string',
        Due: 'string',
        'Current Mileage': 'number',
        'Mileage Interval': 'number',
        'Next Service Mileage': 'number',
        'Date Interval': 'string',
        'Next Service Date': 'date',
        Interval: 'string',
        Repeat: 'string',
        'Expiry Date': 'date',
        'Last Job No': 'string',
        'Job Date': 'date',
      },
    };
  },
  computed: {
    selectedReportCode() {
      return this.selectedReportName?.['ReportCode'] ?? null;
    },
    activeDateFields() {
      const filter = this.dateFieldData.filter((item) => item['Report Key'] == this.selectedReportCode);
      return filter;
    },
    disableDateFields() {
      const disableKeys = ['VEHICLE_AVAILABILITY', 'TYRE_USAGE', 'MAINTENANCE'];
      return disableKeys.includes(this.selectedReportCode);
    },
    disableDateFieldsInjected() {
      const disableKeys = ['VEHICLE_AVAILABILITY', 'TYRE_USAGE', 'MAINTENANCE'];
      return disableKeys.includes(this.injectedReportCode);
    },
    tableGroupBy() {
      if (this.selectedReportCode == 'TYRE_USAGE') {
        if (this.tyreUsageGroupSerialNo) return 'Serial No';
        else if (this.tyreUsageGroupInventoryNo) return 'Vehicle No';
      } else if (
        this.selectedReportCode == 'JOB_ANALYSIS' &&
        this.injectedJobAnalysisType == 'Duration / Mileage Diff.' &&
        this.jobAnalysisGroupByInventoryNo
      ) {
        return 'Vehicle No';
      }

      return '';
    },

    loginDetailsState() {
      return this.$store.state.loginDetails;
    },

    tableHideFiltered() {
      const reportCode = this.injectedReportCode;
      if (reportCode == 'JOB_ANALYSIS') {
        if (this.injectedJobAnalysisType == 'Duration / Mileage Diff.' && this.jobAnalysisGroupByInventoryNo) {
          return this.tableHideColumns;
        } else return [];
      } else if (reportCode == 'TYRE_USAGE') {
        if (this.tyreUsageGroupInventoryNo) return ['Vehicle No'];
      }
      return this.tableHideColumns;
    },

    partTypeSet() {
      const getPartType = this.emsparttypeList.map((item) => item['Part Type']).filter((item) => item);
      return [...new Set(getPartType)].map((item, index) => ({ '#': index + 1, 'Part Type': item }));
    },
    partGroupSet() {
      const getGroupType = this.emsparttypeList.map((item) => item['Part Group']).filter((item) => item);
      return [...new Set(getGroupType)].map((item, index) => ({ '#': index + 1, 'Part Group': item }));
    },
  },
  props: {},
  methods: {
    fromDateCheckBoxClicked: function () {
      if (this.showFromDate == false && this.showToDate == false) {
        this.showToDate = true;
      }
    },
    toDateCheckBoxClicked: function () {
      if (this.showFromDate == false && this.showToDate == false) {
        this.showFromDate = true;
      }
    },
    refreshClearFilter: function () {
      this.injectedReportName = '';
      this.injectedDateField = '';
      this.injectedEquipmentCategory = '';
      this.injectedFromDate = '';
      this.injectedToDate = '';
    },

    tyreUsageGroupSerialClick() {
      this.tyreUsageGroupInventoryNo = false;
      this.refreshTableData();
    },

    tyreUsageGroupVehicleClick() {
      this.tyreUsageGroupSerialNo = false;
      this.refreshTableData();
    },

    refreshTableData() {
      const refresh = this.reportTableData;
      this.reportTableData = [];
      this.$nextTick(() => {
        this.reportTableData = refresh;
      });
    },
    errorDateFieldCheck: function () {
      if (!this.selectedDateField || Object.keys(this.selectedDateField).length === 0) {
        this.errorDateField = 'Please select a Date Field';
        return true;
      }
      return false;
    },
    errorDatePickerCheck: function () {
      if (this.selectedFromDate == null && this.selectedToDate == null) return true;

      if (this.selectedFromDate != null && this.selectedToDate != null) {
        if (this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
          this.errorFromDate = 'From Date > To Date';
          this.errorToDate = 'From Date > To Date';
          return true;
        }
      }
      return false;
    },

    errorReportNameCheck: function () {
      if (!this.selectedReportName || Object.keys(this.selectedReportName).length === 0) {
        this.errorReportName = 'Please select a Report Name';
        return true;
      }
      return false;
    },

    refreshClicked: async function () {
      if (this.errorReportNameCheck()) return;

      this.tableHideColumns = [];
      this.tableDataType = {};

      this.injectedFromDate = this.showFromDate ? this.selectedFromDate : null;
      this.injectedToDate = this.showToDate ? this.selectedToDate : null;

      const formattedStartDate = this.selectedFromDate.formatString('yyyy-MM-dd');
      const formattedEndDate = this.selectedToDate.formatString('yyyy-MM-dd');

      if (this.selectedReportCode == 'EQUIPMENT_POLICY_EXPIRY') {
        if (this.errorDateFieldCheck() || this.errorDatePickerCheck()) {
          this.$fullscreenLoading();
          this.$showAlert('error', 'Filters are incomplete');
          return;
        }

        this.$fullscreenLoading('Refreshing');
        this.reportTableData = [];

        this.injectedEquipmentCategory =
          this.selectedEquipmentCategory.length > 0 ?
            this.selectedEquipmentCategory
              .map((category) => {
                return category['CategoryCode'];
              })
              .join(', ')
          : 'All';

        this.$fullscreenLoading('Getting Table');

        this.reportTableData = await this.$apiCallV2('/EquipmentReport/GetEquipmentPolicyExpiryDate', {
          fromdate: this.showFromDate ? formattedStartDate : '',
          todate: this.showToDate ? formattedEndDate : '',
          equipmentcategorylist:
            this.selectedEquipmentCategory.length > 0 ?
              this.selectedEquipmentCategory.map((category) => {
                return category['CategoryCode'];
              })
            : null,
        });

        const currentDate = new Date();
        for (let policyData of this.reportTableData) {
          for (let policy of this.policyTypes) {
            if (!policyData[policy['PolicyType']]) {
              continue;
            }

            if (
              (new Date(policyData[policy['PolicyType']]) - currentDate) / (1000 * 3600 * 24) <= this.settingvalue &&
              (new Date(policyData[policy['PolicyType']]) - currentDate) / (1000 * 3600 * 24) >= 0
            ) {
              policyData[policy['PolicyType']] =
                `${policyData[policy['PolicyType']]} <img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/warning.png">`;
            } else if (currentDate >= new Date(policyData[policy['PolicyType']])) {
              policyData[policy['PolicyType']] =
                `${policyData[policy['PolicyType']]} <img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/error.png">`;
            }
          }
        }
        this.tableDataType = this.policyExpiryDateDataType;
      } else if (
        this.selectedReportCode == 'STOCK_DAILY_MOVEMENT' ||
        this.selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL'
      ) {
        this.$fullscreenLoading('Getting Stock Movement...');
        let type = '';
        if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT') type = 'SUMMARY';
        else if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL') type = 'DETAIL';

        const requestWarehouse =
          this.dailyWarehouseValue.length > 0 ?
            this.dailyWarehouseValue.map((warehouse) => warehouse['Warehouse Code']).join(',')
          : null;
        const requestItem =
          this.dailyItemValue.length > 0 ? this.dailyItemValue.map((item) => item['Product Code']).join(',') : null;

        const result = await this.$apiCallV2('/EquipmentReport/PrintStockMovement', {
          type: type,
          startdate: this.showFromDate ? formattedStartDate : null,
          enddate: this.showToDate ? formattedEndDate : null,
          warehouse: requestWarehouse,
          item: requestItem,
        });

        this.injectedDailyWarehouse = requestWarehouse ?? 'All';
        this.injectedDailyItem = requestItem ?? 'All';
        this.injectedDailySupplier =
          this.dailySupplierValue.length > 0 ?
            this.dailySupplierValue.map((supplier) => supplier['Supplier Code']).join(', ')
          : 'All';

        let updateTable = [];

        if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT')
          updateTable = result.map((item, index) => {
            const { ProdCode, Name, WhseCode, BatchNo, QtyReceived, QtyIssued, BalanceBefore } = item;
            const qtyRec = Number(QtyReceived ?? 0);
            const qtyIss = Number(QtyIssued ?? 0);
            const qtyMove = qtyRec - qtyIss;
            const qtyBal = Number(BalanceBefore ?? 0) + qtyMove;

            const findWhse = this.warehouseList.find((warehouse) => warehouse['Warehouse Code'] == WhseCode);
            const { Name: whseName } = findWhse || {};
            return {
              '#': index + 1,
              Product: `[${ProdCode}] ${Name}`,
              Warehouse: WhseCode ? `[${WhseCode}] ${whseName ?? ''}` : '',
              'Serial No': BatchNo,
              'Balance Before': BalanceBefore,
              'Qty Received': qtyRec,
              'Qty Issued': qtyIss,
              'Qty Change': qtyMove,
              'Qty Balance': qtyBal,
            };
          });
        else if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL')
          updateTable = result.map((item, index) => {
            const { ProdCode, Name, WhseCode, BatchNo, Date: movDate, QtyReceived, QtyIssued, JobNo, VehicleNo, Spp_Code: SppCode } = item;
            const qtyRec = Number(QtyReceived ?? 0);
            const qtyIss = Number(QtyIssued ?? 0);

            const findWhse = this.warehouseList.find((warehouse) => warehouse['Warehouse Code'] == WhseCode);
            const { Name: whseName } = findWhse || {};

            const findSpp = this.supplierList.find((supplier) => supplier['Supplier Code'] == SppCode);
            const { 'Supplier Name': sppName } = findSpp || {};
            return {
              '#': index + 1,
              Product: `[${ProdCode}] ${Name}`,
              Warehouse: WhseCode ? `[${WhseCode}] ${whseName ?? ''}` : '',
              'Serial No': BatchNo,
              Date: movDate,
              'Qty Received': qtyRec || '',
              'Qty Issued': qtyIss || '',
              'Supplier': SppCode ? `[${SppCode}] ${sppName ?? ''}` : '',
              'Job No': JobNo,
              'Vehicle No': VehicleNo,
            };
          });

        this.tableHideColumns = this.stockMovementTableHide.concat(
          !this.showFromDate ? ['Balance Before', 'Qty Change'] : [],
        );
        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = updateTable;
        });
        this.tableDataType = this.stockDataType;
      } else if (this.selectedReportCode == 'VEHICLE_AVAILABILITY') {
        this.vehicleAvailabilityVehicleValueError = '';

        let error = false;
        if (!this.vehicleAvailabilityVehicleValue) {
          this.vehicleAvailabilityVehicleValueError = 'Vehicle is required';
          error = true;
        }
        if (error) return;

        this.$fullscreenLoading('Getting Vehicle Availability History...');

        const { label: vehicleLabel, 'Inventory #': vehicleNo } = this.vehicleAvailabilityVehicleValue || {};
        this.injectedVehicleAvailabilityVehicle = vehicleLabel;

        const result = await this.$apiCallV2('/EquipmentReport/GetVehicleAvailabilityHistory', {
          vehicleno: vehicleNo,
        });

        const returnData = result.map((item, index) => {
          const { VehicleNo, VehicleCode, Availability, Remark1, AuditDate, AuditUserID } = item;
          return {
            '#': index + 1,
            'Vehicle No': VehicleNo,
            'Vehicle Code': VehicleCode,
            Availability: Availability == '1' ? 'Yes' : 'No',
            Remark: index == 0 ? 'First created' : Remark1,
            'Audit Date': AuditDate,
            'Audit User': AuditUserID,
          };
        });

        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = returnData;
        });
        this.tableDataType = this.vehicleAvailabilityDataType;
      } else if (this.selectedReportCode == 'TYRE_USAGE') {
        let error = false;

        if (error) return;

        this.$fullscreenLoading('Getting Tyre Usage History...');

        const selectedVehicles =
          this.tyreUsageVehicleValue.length > 0 ?
            this.tyreUsageVehicleValue.map((item) => item['Inventory #']).join(',')
          : null;
        this.injectedTyreUsageVehicle = selectedVehicles ?? 'All';

        const selectedVehicleType =
          this.tyreUsageVehicleTypeValue.length > 0 ?
            this.tyreUsageVehicleTypeValue.map((item) => item['Category Code']).join(',')
          : null;
        this.injectedTyreUsageVehicleType = selectedVehicleType ?? 'All';

        const result = await this.$apiCallV2(`/EquipmentReport/GetVehicleTyreUsage`, {
          vehicleno: selectedVehicles,
          vehicletype: selectedVehicleType,
        });
        const order = result.map((item, index) => {
          const {
            VehicleNo,
            SerialNo,
            Model,
            Manufacturer,
            MadeIn,
            TyreSize,
            TyrePosition,
            InUse,
            StartMileage,
            EndMileage,
            DateLastUse,
            DateChange,
            NoOfRetread,
            JobNo,
          } = item;

          const mileageInUse = Number(EndMileage ?? 0) - Number(StartMileage ?? 0);
          const dateInUse = Date.parse(DateChange) - Date.parse(DateLastUse);
          const { label: InUseLabel } = this.tyreUsageTyreStatusTypes.find((item) => item.keyValue == InUse) || {};

          const { 'Inventory Code': InventoryCode } = this.vehicleList.find((item) => item['Inventory #'] == VehicleNo);

          return {
            '#': index + 1,
            'Vehicle No': `[${InventoryCode}] ${VehicleNo}`,
            'Serial No': SerialNo,
            Model: Model,
            Manufacturer: Manufacturer ?? '',
            'Made In': MadeIn ?? '',
            'Tyre Size': TyreSize ?? '',
            'No of Retread': NoOfRetread ?? '',
            'Tyre Position': TyrePosition ?? '',
            'Tyre Status': InUseLabel ?? '',
            'Mileage In Use': mileageInUse,
            'Date Changed': DateChange ? new Date(DateChange).formatString('yyyy-MM-dd') : '',
            'Days In Use': Math.round(dateInUse / (1000 * 60 * 60 * 24)),
            'Date Last Use': DateLastUse ? new Date(DateLastUse).formatString('yyyy-MM-dd') : '',
            'Job No': JobNo,
          };
        });

        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = order;
        });
        this.tableDataType = this.tyreUsageDataType;
      } else if (this.selectedReportCode == 'JOB_ANALYSIS') {
        this.jobAnalysisTypeValueError = '';
        let error = false;
        if (!this.jobAnalysisTypeValue) {
          this.jobAnalysisTypeValueError = 'Report Type is required';
          error = true;
        }
        if (error) return;

        this.$fullscreenLoading('Getting Job Analysis...');

        const { label, keyValue: reportType } = this.jobAnalysisTypeValue || {};

        this.injectedJobAnalysisType = label;

        const vehicleType =
          this.jobAnalysisVehicleTypeValue.length > 0 ?
            this.jobAnalysisVehicleTypeValue
              .map((category) => {
                return category['CategoryCode'];
              })
              .join(',')
          : null;
        this.injectedJobAnalysisVehicleType = vehicleType ?? 'All';

        const result = await this.$apiCallV2(`/EquipmentReport/GetJobAnalysis`, {
          type: reportType,
          startdate: this.injectedFromDate || null,
          enddate: this.injectedToDate || null,
          vehicletype: vehicleType,
        });

        let order = [];

        if (reportType == 'diff') {
          order = result.map((item, index) => {
            const {
              InventoryNo,
              InventoryCode,
              CategoryDesc,
              JobNo,
              JobDate,
              Workshop,
              DateIn,
              TimeIn,
              DateOut,
              TimeOut,
              Amount,
              MeterReading,
              ServicePerson,
            } = item;
            const duration =
              DateOut ? Math.ceil(Math.abs(Date.parse(DateOut) - Date.parse(DateIn)) / (1000 * 60 * 60 * 24)) : '';
            const findNext = index < result.length - 1 ? result[index + 1] : null;
            const nextMileage = findNext?.InventoryNo == InventoryNo ? findNext.MeterReading : null;

            return {
              '#': index + 1,
              'Vehicle No': InventoryNo,
              'Vehicle Code': InventoryCode,
              'Vehicle Category': CategoryDesc,
              'Job No': JobNo,
              'Job Date': JobDate,
              Workshop: Workshop,
              'Date In': DateIn,
              'Time In': TimeIn,
              'Date Out': DateOut ?? '',
              'Time Out': DateOut && TimeIn ? TimeIn : '',
              'Duration (Days)': duration,
              [`Amount (${this.localCurrency})`]: Amount,
              Mileage: MeterReading,
              'Mileage Diff': nextMileage ? MeterReading - nextMileage : '',
              'Service Person': ServicePerson,
            };
          });
        } else if (reportType == 'count') {
          order = result.map((item) => {
            const { InventoryNo, InventoryCode, CategoryDesc, RepairCount, TotalAmount, CurrentMileage, DatePurchase } =
              item;

            return {
              'Vehicle No': InventoryNo,
              'Vehicle Code': InventoryCode,
              'Vehicle Category': CategoryDesc,
              'Total Repair Count': RepairCount,
              [`Total Amount (${this.localCurrency})`]: TotalAmount,
              'Current Mileage': CurrentMileage,
              'Age of Vehicle (Year)': DatePurchase ? this.getAge(DatePurchase) : '',
            };
          });
        }

        this.tableHideColumns = this.jobAnalysisDiffTableHide;

        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = order;
        });

        this.tableDataType = this.jobAnalysisDataType;
      } else if (this.selectedReportCode == 'PARTS_USAGE') {
        const partTypeString =
          this.partsUsagePartTypeValue?.length > 0 ?
            this.partsUsagePartTypeValue.map((item) => item['Part Type']).join(',')
          : null;
        const partGroupString =
          this.partsUsagePartGroupValue?.length > 0 ?
            this.partsUsagePartGroupValue.map((item) => item['Part Group']).join(',')
          : null;

        this.injectedPartsUsagePartType = partTypeString ?? 'All';
        this.injectedPartsUsagePartGroup = partGroupString ?? 'All';

        this.$fullscreenLoading('Getting Parts Usage...');
        const data = await this.$apiCallV2(`/EquipmentReport/GetPartsUsage`, {
          startdate: this.injectedFromDate || null,
          enddate: this.injectedToDate || null,
          parttype: partTypeString,
          partgroup: partGroupString,
        });

        const filterData = data.map((item, index) => {
          const {
            InventoryNo,
            VehicleCode,
            JobNo,
            JobDate,
            PartType,
            PartNo,
            SerialNo,
            DatePurchase,
            Supplier,
            Manufacturer,
            MadeIn,
            Model,
            Size,
            Quantity,
            Cost,
            MileageUse,
            MileageDiff,
            DateOut,
            TyreIndex,
            TyreNaming,
            InvoiceNo,
          } = item;
          const { tyrePosition } = TyreIndex ? this.tyrePositionInfo(TyreIndex) : '';

          return {
            '#': index + 1,
            Vehicle: `[${VehicleCode}] ${InventoryNo}`,
            'Job No': JobNo ?? '',
            'Job Date': JobDate,
            'Part Type': PartType ?? '',
            'Part No': PartNo ?? '',
            'Serial No': SerialNo ?? '',
            'Date Purchase': DatePurchase,
            Supplier: Supplier ?? '',
            Manufacturer: Manufacturer ?? '',
            'Made In': MadeIn ?? '',
            Model: Model ?? '',
            Size: Size ?? '',
            Quantity: Quantity ?? '',
            'Unit Price': Cost && Quantity ? this.$currencyFormat((Number(Cost) / Number(Quantity)).toString()) : '',
            [`Cost (${this.localCurrency})`]: Cost ? this.$currencyFormat(Number(Cost).toString()) : '',
            Mileage: MileageUse ?? '',
            'Usage (KM)': MileageDiff ?? '',
            'Cost per KM': MileageDiff ? this.$currencyFormat((Number(Cost) / Number(MileageDiff)).toString()) : '',
            'Date Out': DateOut ?? '',
            'Tyre Position': (TyreNaming || tyrePosition) ?? '',
            'Invoice No': InvoiceNo,
          };
        });
        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = filterData;
        });

        this.tableDataType = this.partUsageDataType;
      } else if (this.selectedReportCode == 'MAINTENANCE') {
        this.$fullscreenLoading('Getting Maintenance...');

        const selectedVehicleType =
          this.maintenanceVehicleTypeValue.length > 0 ?
            this.maintenanceVehicleTypeValue.map((item) => item['CategoryCode']).join(',')
          : null;
        this.injectedMaintenanceVehicleTypeValue = selectedVehicleType ?? 'All';

        const data = await this.$apiCallV2(`/EquipmentReport/GetMaintanceList`, {
          vehicletype: selectedVehicleType,
        });
        const returnData = data.map((item, index) => {
          const {
            InventoryNo,
            VehicleCode,
            ServiceCode,
            ServiceDesc,
            Task,
            TaskDesc,
            Remark,
            MeterReading: meterreading,
            Duration,
            Mileage,
            Repetitive,
            ExpireDate,
            JobNo,
            JobDate,
            SerVariant,
            DateCreated,
          } = item;
          const MeterReading = meterreading ?? 0;
          const nextMileage = Number(Mileage) + Number(MeterReading);
          const durationString = SerVariant == '2' ? `${Duration} Months` : `${Duration} Days`;
          const getNextDuration = () => {
            const startDateString = JobDate ?? DateCreated;
            if (!startDateString || !Duration) return '';
            const durationNum = Number(Duration);
            const nextDate = new Date(startDateString);
            if (SerVariant == '2') nextDate.setDate(nextDate.getDate() + durationNum);
            else if (SerVariant == '2') nextDate.setMonth(nextDate.getMonth() + durationNum);
            return new Date(nextDate);
          };
          const getNextDurationString = () => {
            const date = getNextDuration();
            return date ? date.formatString('yyyy-MM-dd') : '';
          };
          const isDue = () => {
            if (JobNo && Repetitive == '0') return 'No';
            if (['0', '3'].includes(SerVariant)) {
              if (Number(MeterReading) > nextMileage) return 'Yes';
            }
            const nextDuration = getNextDuration();
            if (!nextDuration) return 'No';

            if (new Date() >= new Date(nextDuration)) return 'Yes';

            return 'No';
          };

          const SerVariantString = () => {
            if (SerVariant == '0') return 'Mileage';
            else if (SerVariant == '1') return 'Months';
            else if (SerVariant == '2') return 'Days';
            else if (SerVariant == '3') return 'Which Comes First';
          };
          return {
            '#': index + 1,
            Vehicle: `[${[VehicleCode]}] ${InventoryNo}`,
            Service: `[${ServiceCode}] ${ServiceDesc}`,
            Task: `[${Task}] ${TaskDesc}`,
            Remarks: Remark ?? '',
            Due: isDue(),
            'Current Mileage': MeterReading ?? '',
            'Mileage Interval': Mileage ?? '',
            'Next Service Mileage': ['0', '3'].includes(SerVariant) ? nextMileage : '',
            'Date Interval': Duration ? durationString : '',
            'Next Service Date': Duration ? getNextDurationString() : '',
            Interval: SerVariantString(),
            Repeat: Repetitive == '1' ? 'Routine' : 'Once Only',
            'Expiry Date': ExpireDate ? new Date(ExpireDate).formatString('yyyy-MM-dd') : '',
            'Last Job No': JobNo ?? '',
            'Job Date': JobDate ? new Date(JobDate).formatString('yyyy-MM-dd') : '',
          };
        });

        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = returnData;
        });

        this.tableDataType = this.maintenanceDataType;
      }

      this.injectedReportName = this.selectedReportName['Report'];
      this.injectedReportCode = this.selectedReportName['ReportCode'];

      this.injectedDateField = this.selectedDateField?.['Date Field'] ?? '';

      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');

      this.$fullscreenLoading();

      this.filtersIsCollapsed = true;
    },

    resetDateFields() {
      this.selectedDateField = this.activeDateFields[0];
    },

    //fetch data
    async getReportNameList() {
      this.reportNameData = await this.$apiCallV2('/EquipmentReport/GetListMaster?masterfile=RPT_REPORT&module=EMS');
    },

    async getReportDateFields() {
      this.dateFieldData = await this.$apiCallV2(
        '/EquipmentReport/GetListMaster?masterfile=RPT_REPORT_DATEFIELD&module=EMS',
      );
    },

    async getEquipmentCategoryList() {
      this.equipmentCategoryList = await this.$apiCallV2('/EquipmentReport/GetVehicleCategory');
    },

    async getSystemSettings() {
      this.settingvalue = await this.$apiCallV2('/EquipmentReport/GetSettingsSystem?settingsitem=DrvExpAlertDays');
      this.settingvalue = this.settingvalue[0]['SettingsValue'];
      if (this.settingvalue == null || this.settingvalue == '') this.settingvalue = 7;
    },

    async getWarehouseList() {
      this.warehouseList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'WAREHOUSE' });
    },

    async getwhProductList() {
      this.whProductList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'WHPRODUCT' });
    },

    async getSupplierList() {
      this.supplierList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SUPPLIER' });
    },
    async getVehicleList() {
      this.vehicleList = (await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VEHICLE' })).map((item) => {
        const { 'Inventory #': InventoryNo, 'Inventory Code': InventoryCode } = item;
        return {
          ...item,
          label: `[${InventoryNo}] ${InventoryCode}`,
        };
      });
    },

    async getPartsType() {
      this.emsparttypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMSPARTTYPE' });
    },

    async getLocalCurrency() {
      const companyDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'COMPANY',
        module: 'MASTER',
        recordid: this.$store.state.loginDetails.CoCode,
      });
      if (companyDetails.CompanyLocalCur) this.localCurrency = companyDetails.CompanyLocalCur;
    },

    //helper
    getAge(dateString) {
      const today = new Date();
      const birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();

      // Check if the birthday has occurred yet this year
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      return age;
    },

    tyrePositionInfo(tyreIndex) {
      const align =
        tyreIndex <= 49 ? 'L'
        : tyreIndex <= 99 ? 'R'
        : 'S';

      const rowNo = tyreIndex < 100 ? (tyreIndex % 10) + 1 : 0;

      let tyrePosition = '';
      if (align == 'L') {
        tyrePosition = rowNo >= 1 && rowNo <= 5 ? 'FL' : 'RL';
      } else if (align == 'R') {
        tyrePosition = rowNo >= 1 && rowNo <= 5 ? 'FR' : 'RR';
      } else if (align == 'S') {
        tyrePosition = 'SP';
      } else {
        tyrePosition = rowNo == 0 ? 'FC' : 'RC';
      }

      let columnNo = 0;
      if (tyreIndex < 100) {
        const strIndex = tyreIndex.toString();
        const firstDigit = strIndex.length == 1 ? 0 : parseInt(strIndex[0], 10);
        columnNo = firstDigit + 1;
      }

      return { align, tyrePosition, rowNo, columnNo };
    },
  },
  async mounted() {
    this.closeLeftTab = false;
    // this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');

    var date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.$fullscreenLoading('Getting Report Settings');

    // this.policyTypes = await this.$apiCallV2('/EquipmentReport/GetListMaster?masterfile=POLICYTYPE');
    // for (let policy of this.policyTypes) {
    //   this.policyExpiryDateDataType[policy['PolicyType']] = 'date';
    // }
    await Promise.all([
      this.getReportNameList(),
      this.getReportDateFields(),
      this.getEquipmentCategoryList(),
      this.getSystemSettings(),
      this.getWarehouseList(),
      this.getwhProductList(),
      this.getSupplierList(),
      this.getVehicleList(),
      this.getPartsType(),
    ]);

    this.$fullscreenLoading();
  },
  watch: {
    loginDetailsState() {
      this.getLocalCurrency();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Equipment-Report-Main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 5px 10px 45px;
  display: flex;
  overflow: hidden;

  .content-container {
    display: flex;
    width: 100%;
    gap: 4px;
  }

  .left-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;
    resize: horizontal;
    overflow: auto;
    width: 260px;
    min-width: 170px;
    max-width: 30%;
  }

  .filter-container {
    border-radius: 4px;
    padding: 8px;
    padding-top: 4px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 2px;
    position: relative;
    min-height: 0;
  }

  .active-filter-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
    overflow: auto;
  }

  .table-container {
    min-height: 0;
    flex-grow: 1;
    padding: 8px;
    padding-top: 0px;
    background-color: white;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
  }

  .filters-main {
    flex-shrink: 0;
  }
}
</style>
